

//------------------imports--------------
import * as React from "react";
import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import AppBar from "@mui/material/AppBar";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import CircularProgress from "@mui/material/CircularProgress";

import Navbar from "../../components/common/Navbar";
import { useStyles } from "../../assets/styles/Theme";
import ViewData from "../../components/grids/ViewDatagrid";
import { InvSubCatergorydata } from "../../assets/Griddata";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import { useState, useEffect } from "react";
import { externalgetApi } from "../../services/external/externalApis";
import { InvCategory_01, InvSubCategory_01, SETTINGS_API_08 } from "../../api/ApiModel";
import { useSelector } from "react-redux";
import {
  CON_STATUS_ACTIVE,
  CON_MENU_TYPE_CODE,
} from "../../utils/sys/Constants";
import SearchAppBar from "../../components/common/search";
import { Autocomplete, TextField } from "@mui/material";
function ViewSubcategory() {
  //------------------hooks------------------------
  const navigate = useNavigate();
  const theme = useTheme();
  const styles = useStyles(theme);

  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [filteredData, setFilteredData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
   const [datacat, setDatacat] = useState([]);
    const [datacat1, setDatacat1] = useState([]);
    const [selectedcatcode, setSelectedcatcode] = useState("");
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, LOCCODE, RESTCODE } = SYS_USER.USER_PARAM || {};

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await externalgetApi(InvSubCategory_01, "get", {
          COMPCODE,
        CATCODE: selectedcatcode,
          STS: CON_STATUS_ACTIVE,
        });
        setData(result);
            console.log("Fetched Data:", result);
        setIsLoading(false);
    
      } catch (err) {
        setError(err);
        setIsLoading(false);
      }
    };

    fetchData();
  }, [selectedcatcode]);

   useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await externalgetApi(InvCategory_01, "get", {
          COMPCODE,
          STS: CON_STATUS_ACTIVE,
        });
        setDatacat(result);
        // Set default category to first item if available
        if (result && result.length > 0) {
          setSelectedcatcode(String(result[0].CATCODE));
        }
        console.log("result", result);
      } catch (err) {
        setError(err);
      }
    };
  
    fetchData();
  }, []);

  const mapResultToRows = (result) => {
    return result.map((item, index) => ({
      id: index + 1,
      SUBCATCODE: item.SUBCATCODE,
      SUBCATNAME: item.SUBCATNAME,
      COLORCODE: item.COLORCODE,

    }));
  };

  useEffect(() => {
    if (data) {
      const filtered = data.filter((item) => {
        return (
          item.SUBCATNAME.toLowerCase().includes(searchText.toLowerCase()) ||
          item.SUBCATNAME.toString()
            .toLowerCase()
            .includes(searchText.toLowerCase())
        );
      });
      setFilteredData(filtered);
    }
  }, [searchText, data]);

  //----------------------functions--------------------------

  const handleSearchChange = (event) => {
    setSearchText(event.target.value);
  };

  const handleItemClick = (id, actionText) => {
    if (actionText === "Edit") {
      const selectedItem = data.find((item) => item.SUBCATCODE === id);
      if (selectedItem) {
        navigate(`/invsubcategory`, { state: { selectedItem, actionText } });
      }
    } else {
      navigate(`/invsubcategory`, { state: { selectedItem: "" } });
    }
  };

  const menuItems = [
    {
      text: "Edit",
      icon: <BorderColorOutlinedIcon />,
      onClick: (SUBCATCODE) => handleItemClick(SUBCATCODE, "Edit"),
    },
  ];

  const rows = filteredData ? mapResultToRows(filteredData) : [];

  return (
    <div>
      <Navbar />
      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer1}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs2}
                // position="fixed"
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="none">Home</Link>
                <Link underline="none">Settings</Link>
                <Link underline="none">View Subcategory</Link>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12} md={6} p={2}>
              <Stack
                sx={styles.AI_fixedStack1}
                direction="row"
                justifyContent="flex-end"
                spacing={2}
                padding={1}
                ml={1}
              >
                <SearchAppBar
                  onChange={handleSearchChange}
                  value={searchText}
                />
                 <Autocomplete
                  options={Array.isArray(datacat) ? datacat : []}
                  getOptionLabel={(option) => option.CATNAME || ""}
                  disableClearable
                  value={
                    Array.isArray(datacat)
                      ? datacat.find(
                          (item) => String(item.CATCODE) === String(selectedcatcode)
                        ) || null
                      : null
                  }
                  onChange={(event, newValue) => {
                    setSelectedcatcode(newValue ? String(newValue.CATCODE) : "");
                    // Optionally, trigger a product fetch/filter here
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name="catcode"
                      label={<span>Category Name</span>}
                      variant="outlined"
                      sx={{
                        width: "100%",
                        minWidth: 220,
                      }}
                      size="small"
                    />
                  )}
                  ListboxProps={{
                    sx: {
                      maxHeight: 150,
                      backgroundColor: theme.palette.background.paper,
                      "& .MuiAutocomplete-option": {
                        "&:hover": {
                          backgroundColor: theme.palette.primary.light,
                        },
                        "&.Mui-focused": {
                          backgroundColor: theme.palette.primary.main,
                          color: theme.palette.common.white,
                        },
                      },
                    },
                  }}
                />
                <Button
                  onClick={() => handleItemClick()}
                  variant="contained"
                  size="medium"
                  startIcon={<AddCircleIcon />}
                  sx={{
                    background: theme.palette.primary.main,
                    color: theme.palette.text.buttontxt,
                    textTransform: "capitalize",
                    letterSpacing: "2px",
                    width: "80px",
                  }}
                >
                  Add
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </AppBar>

      {isLoading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "60vh",
          }}
        >
          <CircularProgress color="primary" />
        </Box>
      ) : (
        <ViewData
          columns={InvSubCatergorydata.columns}
          rows={rows.map((item) => ({ ...item, id:item.SUBCATCODE }))}
          menuItems={menuItems}
          tabletitle={InvSubCatergorydata.name}
          gridid="SUBCATCODE"
        />
      )}
    </div>
  );
}

export default ViewSubcategory;
